Backbone.Radio.channel('views').reply('form-donation',function(options){
	console.log('o',options)
	var radio = Backbone.Radio.channel('pledgeform')
	
	var opts = {
		 type:"sustainer"
		,amount:0
		,term:""
	}
	
	
	/*
	 *	Public
	 *		Events
	 */
	radio.reply('donation:request',function(){
		triggerUpdated(); 
	})
	
	/*
	 *	Trigger	
	 *		Events
	 */
	var triggerUpdated = function(){
		opts.term = (opts.type =='sustainer')? 'M' : ''; //one-time/monthly/etc. Sustainer is always monthly. One-Time is empty
			//volunteers have the installment option
			if($('#installmentTab').hasClass('ui-tabs-active')){ opts.term = $('#paymentTerms').val(); }

		radio.trigger("donation:updated",{
			 type:opts.type
			,amount:opts.amount
			,term:opts.term
		})
	}	
	
	
	
	
	/*
	 *	The View
	 */
	var view = Marionette.View.extend({
		 model:options.model
		,prepopulatedData:options.prepopulatedData
		,openPledges:options.openPledges
		,template:_.template($("#tmpl-form-donation").html())
		,templateContext:function(){
			var allowSustainer = true;
			var allowOnetime = true;
			var allowInstallments = false;
			var activeSustainer = false;
			
			if( typeof this.model != "undefined"){ //undefined means we're on public pledge, so will not have a default payment method at all
				//Do we have usable payment methods?
				var paymentMethodEFTorCredit = _.some(_.pluck(this.model.attributes.payment_method, 'rC_Giving__Payment_Type__c'), function(v){
					return ["Charge Card","EFT"].indexOf(v) >= 0;
				});
				if(!paymentMethodEFTorCredit){
					/*** NOTE THIS GETS OVERWRITTEN IF THEY COME IN WITH THE t=up QUERYSTRING. 
						PERHAPS ONLY RELEVANT FOR 'CASH/CHECK' SUSTAINERS. ***/
					allowSustainer = false;
				}
				
				/* If we can't charge the payment method on their active sustaining pledge, we can't let them update the sustaining
					pledge at all. Eg, `payroll deduction` where Finance controls the pledge. */
				if( this.openPledges && this.openPledges.attributes.sustainers[0] 
					&& this.openPledges.attributes.sustainers[0].rC_Giving__Payment_Method_Selected__r.rC_Giving__Payment_Type__c !== "Charge Card"
					&& this.openPledges.attributes.sustainers[0].rC_Giving__Payment_Method_Selected__r.rC_Giving__Payment_Type__c !== "Cash/Check"
					&& this.openPledges.attributes.sustainers[0].rC_Giving__Payment_Method_Selected__r.rC_Giving__Payment_Type__c !== "EFT" ){
					
					allowSustainer = false;
				}
			}
			if( this.openPledges && this.openPledges.attributes.sustainers[0]){
				activeSustainer = true;
			}
			
			//this is triggered from the 'Additional Gift' button on the profile page
			if(Backbone.settings.qs.t === "add"){
				allowSustainer = false;
			}
			
			//this is triggered from the 'Upgrade Sustainer' button on the profile page
			if(Backbone.settings.qs.t === "up"){
				allowOnetime = false;
				allowSustainer = true; //force allow sustainer regardless of payment type. Control for payroll deduction from where the button lives on the profile page
				opts.type="sustainer"; //sustainer is default, but other things can change it before we get here. This is mostly to account for 'Cash/Check' Sustainers
			}
			
			if(allowSustainer===false){
				opts.type="normal"; //default is sustainer, so update that if we can't have sustainer pledges
			}
			
			if(Backbone.settings.flags.volunteer
			|| Backbone.settings.flags.callcenter){
				allowInstallments = true;
			}
			
			return {
				 allowSustainer:allowSustainer
				,allowOnetime:allowOnetime
				,allowInstallments:allowInstallments
			}
		}
		,events:{
			 "click input[type=radio]":"amountClicked"
			,"change #sustainerOtherInput":"otherUpdated"
			,"change #onetimeOtherInput":"otherUpdated"
			 //tabsactive is an event from tabs (ie, jquery ui)
			,"tabsactivate #pledgeAmountTabs":"typeClicked"
			,"change #installmentAmount":"installmentUpdated"
			,"change #paymentTerms":"paymentTermsUpdated"
		}
		,typeClicked:function(e,ui){
			console.log("typeClicked")
			if(ui.newTab[0].id === 'sustainerTab'){ opts.type = "sustainer"; }
			else if(ui.newTab[0].id === 'installmentTab'){ opts.type = "installment"; }
			else{ opts.type = "normal"; }
			
			//clear amounts
			$('#onetimeOtherInput').val('')
			$('#sustainerOtherInput').val('')
			$('[name=onetimePledge]').prop('checked',false)
			$('[name=sustainingPledge]').prop('checked',false)
			$('#sustainerAmount').val(0);
			$('#onetimeAmount').val(0);
			$('#installmentAmount').val(0);
			$('#sustainerDonationMessage').empty();
			$('#onetimeDonationMessage').empty();
			opts.amount=0;
			
			triggerUpdated()
		}
		,amountClicked:function(e){
			// Clear min donation msg when other amt is selected
			$('#sustainerDonationMessage').empty();
			$('#onetimeDonationMessage').empty();
			
			var amount = $(e.currentTarget).val();
			var targetInput;
			if( !amount ){ //'Other' has been selected
				targetInput = $(e.currentTarget).parent().find('input[type=text]');
				targetInput.focus();
				if( !targetInput.val().length ){
					amount = '';	
				}else{
					amount = accounting.toFixed( targetInput.val(), 2);
				}
			}else{
				//one of the set-amount radio buttons was selected, so clear the 'other' inputs
				this.$el.find('input[type=text]').val("")
			}
			
			opts.amount = +amount;
			
			triggerUpdated()
		}
		,otherUpdated:function(e){
			if( !this.$el.find(e.currentTarget).val().length ) return;
			var amount = accounting.toFixed( this.$el.find(e.currentTarget).val(), 2);
			this.$el.find(e.currentTarget).val(amount) //set the formatted amount
			
			//be sure the 'other' radio button is selected
			$(e.currentTarget).parent().find('input[type=radio]').attr('checked', true)
			
			opts.amount = +amount;
			
			// Donation msg if donation is less than $5/mon or $60 one time donation
			if(opts.type == "sustainer"){
				if(+amount < 5){
					var htm = ""; 
					htm += "<p>A minimum of $5 per month is required to access PBS Passport</p>"
				}
				$('#sustainerDonationMessage').empty().append(htm);
			} else if(opts.type == "normal"){
				if(+amount < 60){
					var htm = ""; 
					htm += "<p>A minimum of $60 is required to access PBS Passport</p>"
				}
				$('#onetimeDonationMessage').empty().append(htm);
			}
			
			
			triggerUpdated()
		}
		,installmentUpdated:function(e){
			var amount, q;
			if(!this.$el.find(e.currentTarget).val().length){
				this.$el.find('#quarterly').text = "Quarterly (4 Installments)";
				this.$el.find('#monthly').text = "Monthly (12 Installments)";
				amount = 0;
			}else{
				amount = this.$el.find('#installmentAmount').val();
				if( typeof +amount === 'number' && !isNaN(amount) ){
					q = +amount / 4;	
					document.getElementById('quarterly').text = 'Quarterly (4 Installments of $'+ accounting.toFixed(q,2) +')';
					
					q = +amount / 12;
					document.getElementById('monthly').text = 'Monthly (12 Installments of $'+ accounting.toFixed(q,2) +')';
				}					
			}
			
			opts.amount = +amount;
			triggerUpdated();
		}
		,paymentTermsUpdated:function(){
			triggerUpdated();
		}
		,onAttach:function(){
			/* tabs is from jQuery UI. */
			this.$el.find('#pledgeAmountTabs').tabs();
			
			/* pTooltip has its own lib file */
			this.$el.find('#sustainerReadMore').pTooltip();
			if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
				this.$el.find('#sustainerReadMore')
					.on('click', function(){
						$('#sustainerReadMoreMobile').toggle();
					})	
			}
			
			/* Type/Amount came in through the querystring, so set them */
			if(Backbone.settings.qs.amount && Backbone.settings.qs.type){
				if(Backbone.settings.qs.type == 'onetime'){
					$('#ui-id-2').trigger('click') //the one-time donation tab
					$('#onetimeOtherInput').val(Backbone.settings.qs.amount).trigger('change')
					$('#onetimeOther').find('input[name="onetimePledge"]').trigger('click')
				}else if(Backbone.settings.qs.type == 'sustainer'){
					//the sustainer tab is enabled by default, so don't do anything
					$('#sustainerOtherInput').val(Backbone.settings.qs.amount).trigger('change')
				}
			}

			/* Type/Amount/other things came in through the `prepopulatedData` var */
			if(this.prepopulatedData){
				if(this.prepopulatedData.type &&
				   this.prepopulatedData.type==="sustainer"){
					   //the sustainer tab is enabled by default, so don't do anything
					   if(this.prepopulatedData.amount){
						   $('#sustainerOtherInput').val(this.prepopulatedData.amount).trigger('change')
					   }
					   
				   }
			}
			
			/* If user has an active Sustainer, default the tab to the one-time tab */
			if( this.openPledges && this.openPledges.attributes.sustainers[0] ){
				$('#ui-id-2').trigger('click') //the one-time donation tab	
			}
			
			
			if(Backbone.settings.qs.cat && Backbone.settings.qs.cat==="tickets"){
				$('#ui-id-2').trigger('click') //the one-time donation tab	
			}
			
			/* Settings may change while building the template, but triggers don't work there since
				the other pieces aren't attached yet. So always fire off whatever settings we ended up with
				once this is actually on the dom */
			triggerUpdated();
		}
	})
	
	
	return new (view)();
});